import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { renderArrayObjectValueWithComas } from '../../../../../Facebook/LineItemForms/LineItemFacebookEdit/Sections/CustomAudiencesSection/helpers'

import { getCustomAudiences, getCustomAudiencesExclusion } from './helpers'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'
import { audiencesSelector } from '../../../../../../modules/selectors/audiences'

function AudienceSectionPreview() {
  const { t } = useTranslation()

  const targeting = useSelector(dv360TargetingSelector)
  const audiences = useSelector(audiencesSelector)

  const customAudiences = getCustomAudiences(targeting, audiences)
  const customAudiencesExclusion = getCustomAudiencesExclusion(targeting, audiences)

  if (!customAudiences.length && !customAudiencesExclusion) {
    return null
  }

  return (
    <p>
      {!!customAudiences.length && (
        <span>
          {t('Custom audience inclusions: ')}
          {renderArrayObjectValueWithComas(customAudiences, 'name')}
        </span>
      )}
      {!!customAudiencesExclusion.length && (
        <span>
          {t('Custom audience exclusions: ')}
          {renderArrayObjectValueWithComas(customAudiencesExclusion, 'name')}
        </span>
      )}
    </p>
  )
}

export default AudienceSectionPreview
